import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Page403Component } from './page403/page403.component';

import { Page404Component } from './page404/page404.component';
import { Page500Component } from './page500/page500.component';
import { logoutComponent } from './logout/logout.component';

const routes: Routes = [
    {
        path: '404',
        component: Page404Component
    },
    {
        path: '403',
        component: Page403Component
    },
    {
        path: '500',
        component: Page500Component
    },
    {
        path: 'logout',
        component: logoutComponent
    }
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ExtrapagesRoutingModule { }
